export default {
  basketFileImport: null,
}
